import React from 'react'
import { Box, Typography, useTheme } from '@material-ui/core'

const TYPOGRAPHY_COLORS = [
  'initial',
  'inherit',
  'primary',
  'secondary',
  'textPrimary',
  'textSecondary',
  'error',
]

export const DataCounter = ({
  title = 'Title',
  size = 'h3',
  value = 0,
  titleColor = 'textPrimary',
}) => {
  const theme = useTheme()
  const isNativeColor = TYPOGRAPHY_COLORS.includes(titleColor)
  const customColor =
    !isNativeColor && theme.palette[titleColor] ? theme.palette[titleColor].main : undefined

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={3}>
      <Typography
        variant="subtitle1"
        color={isNativeColor ? titleColor : 'initial'}
        style={customColor ? { color: customColor } : undefined}
      >
        {title}
      </Typography>

      <Typography variant={size} color="textPrimary">
        {value}
      </Typography>
    </Box>
  )
}
